import gql from 'graphql-tag';

export const CALENDAR_EVENT_FRAGMENT = gql`
  fragment CalendarEventFields on DealEventActivityViewModel {
    id
    allDay
    subject
    priority
    eventType
    description
    activityStatus
    endAt
    startAt
    endDate
    startDate
  }
`;
